import { createFileRoute } from '@tanstack/react-router'
import { MyAvailability } from '@/features/my-availability'
import { requireBsohtakDoctor } from '@/lib/route-guards'

export const Route = createFileRoute('/_authenticated/my-availability')({
  beforeLoad: requireBsohtakDoctor,
  component: MyAvailability,
})
